// BCFValidationService (§30). Kontroluje integritu témat/viewpointů/komponent a
// workflow pravidla. Rozlišuje ERROR / WARNING / INFO.
import { isValidGuid } from "../core/ids.js";

export const SEVERITY = Object.freeze({ ERROR: "ERROR", WARNING: "WARNING", INFO: "INFO" });

export class BCFValidator {
  constructor({ resolver } = {}) { this.resolver = resolver; }

  validateTopic(topic) {
    const issues = [];
    const add = (severity, code, message) => issues.push({ severity, code, message, topicId: topic.id });

    if (!isValidGuid(topic.id)) add(SEVERITY.ERROR, "INVALID_GUID", "Neplatný GUID tématu.");
    if (!topic.title) add(SEVERITY.WARNING, "MISSING_TITLE", "Téma nemá název.");
    if (!topic.status) add(SEVERITY.ERROR, "MISSING_STATUS", "Téma nemá stav.");
    if (!topic.createdAt) add(SEVERITY.WARNING, "MISSING_CREATED", "Chybí datum vytvoření.");
    if (!topic.createdBy) add(SEVERITY.INFO, "MISSING_AUTHOR", "Chybí autor.");

    for (const c of topic.comments || []) {
      if (!isValidGuid(c.id)) add(SEVERITY.ERROR, "INVALID_COMMENT_GUID", "Neplatný GUID komentáře.");
      if (c.viewpointId && !(topic.viewpoints || []).some((v) => v.id === c.viewpointId)) add(SEVERITY.WARNING, "DANGLING_VIEWPOINT", "Komentář odkazuje na neexistující viewpoint.");
    }
    for (const v of topic.viewpoints || []) {
      if (!isValidGuid(v.id)) add(SEVERITY.ERROR, "INVALID_VIEWPOINT_GUID", "Neplatný GUID viewpointu.");
      if (!v.camera) add(SEVERITY.WARNING, "VIEWPOINT_NO_CAMERA", "Viewpoint nemá kameru.");
      if (!v.snapshot) add(SEVERITY.INFO, "VIEWPOINT_NO_SNAPSHOT", "Viewpoint nemá snímek.");
      if (this.resolver) {
        const r = this.resolver.resolveMany(v.selection || []);
        if (r.missing.length) add(SEVERITY.INFO, "COMPONENTS_MISSING", `${r.missing.length} z ${r.total} prvků viewpointu nebylo v aktuální verzi modelu nalezeno.`);
      }
    }
    return issues;
  }

  validateProject(project) {
    let all = [];
    const seen = new Set();
    for (const t of project.topics || []) {
      if (seen.has(t.id)) all.push({ severity: SEVERITY.ERROR, code: "DUPLICATE_GUID", message: "Duplicitní GUID tématu.", topicId: t.id });
      seen.add(t.id);
      all = all.concat(this.validateTopic(t));
    }
    return { issues: all, errors: all.filter((i) => i.severity === SEVERITY.ERROR).length, warnings: all.filter((i) => i.severity === SEVERITY.WARNING).length };
  }
}
